import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: ${props => props.fontSize || '12px'};
  color: var(--text-muted);
  justify-content: ${props => props.align || 'flex-start'};
`;

const Crumb = styled.span`
  color: ${props => props.active ? 'var(--text-primary)' : 'var(--text-muted)'};
  font-weight: ${props => props.active ? '600' : '400'};
  cursor: ${props => props.active ? 'default' : 'pointer'};
  transition: color 0.2s ease;

  &:hover {
    color: ${props => props.active ? 'var(--text-primary)' : 'var(--accent)'};
  }
`;

const Separator = styled.span`
  color: var(--glass-border-hover);
  margin: 0 4px;
`;

const BreadcrumbWidget = ({ node }) => {
  const align = node.style?.desktop?.align || 'flex-start';
  const fontSize = node.style?.desktop?.fontSize || '12px';
  const separatorChar = node.content?.separator || '/';
  
  const crumbsRaw = node.content?.crumbs || "Startseite,Produkte,Smartphones,iPhone 15";
  const crumbs = crumbsRaw.split(',').map(c => c.trim()).filter(c => c);

  return (
    <Wrapper align={align} fontSize={fontSize}>
      {crumbs.map((crumb, idx) => {
        const isLast = idx === crumbs.length - 1;
        return (
          <React.Fragment key={idx}>
            <Crumb active={isLast}>{crumb}</Crumb>
            {!isLast && <Separator>{separatorChar}</Separator>}
          </React.Fragment>
        );
      })}
    </Wrapper>
  );
};

registry.register('breadcrumb', {
  label: 'Breadcrumbs',
  icon: '🍞',
  category: 'advanced',
  defaultContent: {
    crumbs: "Startseite,Produkte,Smartphones,iPhone",
    separator: "/"
  },
  defaultStyle: {
    desktop: {
      align: 'flex-start',
      fontSize: '12px'
    }
  },
  render: BreadcrumbWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Pfad',
          fields: [
            { name: 'content.crumbs', label: 'Ebenen (kommasepariert)', type: 'textarea' },
            { name: 'content.separator', label: 'Trennzeichen (z.B. / oder > )', type: 'text' }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Typografie',
          fields: [
            { name: 'style.desktop.fontSize', label: 'Schriftgröße', type: 'text' },
            { name: 'style.desktop.align', label: 'Ausrichtung', type: 'select', options: [{label:'Links', value:'flex-start'}, {label:'Zentriert', value:'center'}] }
          ]
        }
      ]
    }
  ]
});
